import { formatDateRange } from '../lib/format'
import type { EventSummary } from '../types'

// One line about an event beside others: where, when, how many sessions and
// favorites.
export function EventSummaryLine({ event }: { event: EventSummary }) {
  const dates = event.first_date
    ? formatDateRange(event.first_date, event.last_date)
    : 'Sem datas'
  return (
    <small>
      {event.category}{event.places ? ` · ${event.places}` : ''} · {dates} · {event.sessions} {event.sessions === 1 ? 'horário' : 'horários'}
      {event.saves ? ` · ${event.saves} ${event.saves === 1 ? 'favorito' : 'favoritos'}` : ''}
    </small>
  )
}
